// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/VolumeBasisLine.yaml
// Generated: 2026-10-23T17:45:54.825Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { VolumeBasisLine } from '@/types/forestry/VolumeBasisLine';

/**
 * VolumeBasisLine Service (Read-Only)
 * Query operations for VolumeBasisLine via the ABP API.
 */
export const volumeBasisLineService = new ReadOnlyEntityService<VolumeBasisLine>(
  '/api/forestry/volumebasisline',
  'VolumeBasisLine',
);
